import { useState } from "react";
import {
  TelephoneFill,
  CalendarCheck,
  Telephone,
  Clipboard
} from "react-bootstrap-icons";

import logo from "../assets/iRise-psychology-Logo1.png";

export default function Hero() {
  const [showPhones, setShowPhones] = useState(false);
  const [activeDoctor, setActiveDoctor] = useState(null);

  const doctors = [
    { name: "Dr Benjamin Piper", phone: "07929040880" },
    { name: "Dr René De Barr", phone: "07539447298" }
  ];

  const copyNumber = (number) => {
    navigator.clipboard.writeText(number);
  };

  return (
    <section className="hero py-5">
      <div className="py-5 main-wrap">
        <div className="row justify-content-center">
          <div className="col-lg-9 text-center">

            <div className="d-flex justify-content-center mb-4">
              <div className="hero-logo d-inline-flex align-items-center">
                <img
                  src={logo}
                  alt="iRise Psychology"
                  className="hero-logo-image"
                />
              </div>
            </div>

            <h1 className="display-5 fw-semibold mb-1 brand-text-light">
              LONDON PSYCHOLOGY
            </h1>

            <div className="h2 fw-normal mb-0 text-white">
              AND COUNSELLING SERVICES
            </div>

            <p className="lead text-white mb-4">
              For Your Peace of Mind
            </p>

            <div className="hero-cta d-flex flex-column gap-3 mx-auto">

              {/* Phone button — BLUE */}
              <button
                className="btn btn-outline-brand btn-lg fw-semibold d-flex align-items-center justify-content-center gap-2"
                onClick={() => {
                  setShowPhones(!showPhones);
                  setActiveDoctor(null);
                }}
              >
                <TelephoneFill size={18} />
                Phone
              </button>

              {showPhones && (
                <div className="d-flex flex-column gap-2">

                  {doctors.map((doc) => (
                    <div key={doc.phone} className="d-flex flex-column gap-2">

                      <button
                        className="btn btn-light fw-semibold"
                        onClick={() =>
                          setActiveDoctor(
                            activeDoctor === doc.phone ? null : doc.phone
                          )
                        }
                      >
                        {doc.name} {doc.phone}
                      </button>

                      {activeDoctor === doc.phone && (
                        <div className="d-flex gap-2 justify-content-center">

                          {/* Ring — unchanged */}
                          <a
                            href={`tel:${doc.phone}`}
                            className="btn btn-outline-brand fw-semibold d-flex align-items-center gap-2"
                          >
                            <Telephone size={16} />
                            Ring
                          </a>

                          {/* Copy number — BLUE */}
                          <button
                            className="btn btn-outline-brand fw-semibold d-flex align-items-center gap-2"
                            onClick={() => copyNumber(doc.phone)}
                          >
                            <Clipboard size={16} />
                            Copy number
                          </button>

                        </div>
                      )}

                    </div>
                  ))}

                </div>
              )}

              <a
                className="btn btn-brand-white btn-lg fw-semibold d-flex align-items-center justify-content-center gap-2"
                href="https://mentispsychology.cliniko.com/bookings#location/"
                target="_blank"
                rel="noopener noreferrer"
              >
                <CalendarCheck size={18} />
                Book Online
              </a>

            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
